module.exports = __webpack_public_path__ + "static/load-chart3-d590afaf7f5f3ae9a708e2836989267d.png";